import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=a3d3b35e&"
import script from "./Section.vue?vue&type=script&lang=js&"
export * from "./Section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3d3b35e')) {
      api.createRecord('a3d3b35e', component.options)
    } else {
      api.reload('a3d3b35e', component.options)
    }
    module.hot.accept("./Section.vue?vue&type=template&id=a3d3b35e&", function () {
      api.rerender('a3d3b35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/FormBuilder/Section.vue"
export default component.exports